module.exports = __webpack_public_path__ + "static/media/p2.d08af7d7.png";